import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Select, Store } from "@ngxs/store";
import moment from "moment";
import { Observable } from "rxjs";
import { filter, map, mergeMap, take } from "rxjs/operators";

import { ClienteDTO, InvestigacionDTO, PaisDTO } from "@DTOS";
import { DatosModalInvestigacionBasicos } from "./DatosModalInvestigacionBasicos";
import { ClientesAcciones, State } from "@shared/states";
import { ClientesUtils, Nilable } from "@shared/utils";

@Component({
    selector: "app-modal-investigacion-datos-basicos",
    templateUrl: "./modal-investigacion-datos-basicos.component.html",
    styleUrls: ["./modal-investigacion-datos-basicos.component.scss"]
})
export class ModalInvestigacionDatosBasicosComponent implements OnInit {
    @Select((state: State) => state.clientes.clientes) public clientes: Observable<ClienteDTO[]>;
    @Select((state: State) => state.paises.paises) public paises: Observable<PaisDTO[]>;

    public formGroup = new FormGroup({
        nombre: new FormControl<string>("", [Validators.required]),
        cliente: new FormControl<Nilable<ClienteDTO>>(null, [Validators.required]),
        fechafin: new FormControl<string>(moment().add(15, "days").format("YYYY-MM-DD"), [Validators.required]),
        respuestasMaximas: new FormControl<number>(500, [Validators.required]),
        paises: new FormControl<PaisDTO[]>([])
    });

    constructor(private activeModal: NgbActiveModal, private clientesUtils: ClientesUtils, private store: Store) { }

    ngOnInit() {
        this.store.dispatch(new ClientesAcciones.Obtener());
    }

    public cancelar() {
        this.activeModal.dismiss();
    }

    public async crearCliente() {
        const cliente = await this.clientesUtils.crearClienteAsync();

        if (cliente == null) {
            return;
        }
        this.formGroup.patchValue({
            cliente
        });
    }

    public guardar() {
        if (this.formGroup.invalid) {
            return;
        }
        const datos = new DatosModalInvestigacionBasicos();

        datos.nombreInvestigacion = this.formGroup.value.nombre!;
        datos.cliente = this.formGroup.value.cliente!;
        datos.paises = this.formGroup.value.paises!;
        datos.fechaHasta = moment(this.formGroup.value.fechafin).toDate();
        datos.maxRespuestas = this.formGroup.value.respuestasMaximas!;

        this.activeModal.close(datos);
    }

    public async cargarDatosInvestigacionAsync(investigacion: InvestigacionDTO) {
        this.paises.pipe(
            filter(paises => paises.length !== 0),
            take(1),
            mergeMap(paises => this.clientes.pipe(
                filter(clientes => clientes.length !== 0), take(1),
                map(clientes => ({ paises, clientes }))
            ))
        ).subscribe(({ paises, clientes }) => {
            this.formGroup.setValue({
                nombre: investigacion.nombre,
                cliente: clientes.find(clienteDTO => clienteDTO.id === investigacion.cliente.id),
                paises: [paises.find(paisDTO => investigacion.targetPais.includes(paisDTO.codigo))!],
                fechafin: moment(investigacion.fechaHasta).format("YYYY-MM-DD"),
                respuestasMaximas: investigacion.n
            });
        });
    }
}
